import { render, staticRenderFns } from "./lahanUmumMonitoringCreate.vue?vue&type=template&id=5e589019"
import script from "./lahanUmumMonitoringCreate.vue?vue&type=script&lang=js"
export * from "./lahanUmumMonitoringCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports